/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react'
import { Flex } from '@radix-ui/themes'
import { IconX } from '@tabler/icons-react'
import { ImportQuesitonRes } from '@/types/question.type'
import { Input } from '@/components/ui/input'
import { FileErrs } from '@/features/question-lib/constant'

const FileImportedDetail = ({
  resData,
  fileInputRef,
  setFile,
  file,
}: {
  resData: ImportQuesitonRes
  fileInputRef: any
  setFile: (file: File | null) => void
  file: File | null
}) => {
  const errData = useMemo(() => {
    if (!resData || !resData.question_ids_invalid) {
      return []
    }

    // Group items by each individual invalid column (not by combinations)
    const groupedByColumn = new Map<string, Set<string>>()

    resData.question_ids_invalid.forEach((item) => {
      item.invalid_cols.forEach((col) => {
        if (!groupedByColumn.has(col)) {
          groupedByColumn.set(col, new Set<string>())
        }
        groupedByColumn.get(col)?.add(item.question_id)
      })
    })

    // Convert map to array format
    return Array.from(groupedByColumn.entries()).map(([col, idSet]) => {
      const ids = Array.from(idSet)
      const errMessage = FileErrs[col as keyof typeof FileErrs] || ''

      return {
        errMessage,
        ids,
        invalidCols: [col],
        cols_err: resData.cols_err,
      }
    })
  }, [resData])

  console.log(resData, 'errr', errData)
  return (
    <div>
      <div className='mt-3 mb-2' onClick={() => fileInputRef.current?.click()}>
        <Input
          type='file'
          accept='.csv,.xlsx'
          ref={fileInputRef}
          onChange={(e) => {
            const selected = e.target.files?.[0] ?? null
            setFile(selected)
          }}
          className='hidden'
        />
        {file ? (
          <div className='w-full max-w-[334px] rounded-md border border-[#EAECF0] px-3 py-2'>
            <div className='flex items-center justify-between gap-3'>
              <span
                className='text-foreground truncate text-sm font-bold'
                title={file.name}
              >
                {file.name}
              </span>
              <button
                type='button'
                onClick={(e) => {
                  e.stopPropagation()
                  setFile(null)
                  if (fileInputRef.current) fileInputRef.current.value = ''
                }}
                className='hover:bg-muted inline-flex h-6 w-6 items-center justify-center rounded'
                aria-label='Clear file'
                title='Remove file'
              >
                <IconX size={16} />
              </button>
            </div>
          </div>
        ) : (
          <div className='text-center text-sm'>
            <b className='text-[#5741C6]'>Click to upload</b> or drag and drop
            Excel or CSV
          </div>
        )}
      </div>
      <Flex direction={'column'} gap={'3'}>
        {errData.length > 0 && !resData.cols_err && (
          <div className='mb-3 flex flex-col gap-3'>
            <p className='text-[#079455]'>
              Total valid questions: {resData.valid_question_ids}/
              {resData.total_questions}
            </p>
            <p className='text-[#FF0000]'>
              Total invalid questions: {resData.invalid_question_ids}/
              {resData.total_questions}
            </p>
          </div>
        )}
        {errData.length > 0 && (
          <p className='mt-1 mb-4 text-xs text-[#475467]'>
            Please check these Errors and Questions again. Make sure to follow
            the “
            <a
              href='https://docs.google.com/document/d/1PO4o-C4p0dQjKCM0YNQCM2Ncy3tV9LmnCQgmIp5jxr8/edit?tab=t.0'
              target='_blank'
              rel='noopener noreferrer'
              onClick={(e) => e.stopPropagation()}
              className='text-[#00429a] underline transition-colors hover:text-[#6ca2e9]'
            >
              HOW TO BUILD QUESTION LIBRARY
            </a>
            ” guide.
          </p>
        )}
        {errData.length > 0 && !resData.cols_err ? (
          <div className='max-h-[300px] overflow-auto rounded-[8px] border border-[#E5E5E5] px-4 py-1.5'>
            <div className='grid grid-cols-2 gap-1.5 text-[11px] font-bold'>
              <p>Error</p>
              <p>Question_ID</p>
            </div>

            {errData.map((item, index) => (
              <div key={index} className='grid grid-cols-2 gap-1.5 text-[13px]'>
                <p className='w-full break-words'>
                  <span className='font-bold'>
                    {item.invalidCols.join(', ')}
                  </span>{' '}
                  - {item.errMessage}
                </p>
                <p className='font-normal'>{item.ids.join(', ')}</p>
              </div>
            ))}
          </div>
        ) : (
          <div className='max-h-[300px] overflow-auto rounded-[8px] border border-[#E5E5E5] px-4 py-1.5'>
            <p className='text-[13px]'>{resData.cols_err}</p>
          </div>
        )}
      </Flex>
    </div>
  )
}

export default FileImportedDetail
